module.exports = __webpack_public_path__ + "img/banner_file.bf42456c.png";